import { compose, createStore, applyMiddleware, CombinedState } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

import { reducers } from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IApplicationStateInitial, TReduxActions } from '../../types/redux';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/* istanbul ignore next */
const composeEnhancers = (() => {
  if (process.env.NODE_ENV === 'development' && process.env.IS_BROWSER_BUILD) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: `dailyrent-search-frontend# ${document.title}`,
        trace: true,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  }

  return compose;
})();

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 */
export function createReduxStore(initialState: IApplicationStateInitial, context: IApplicationContext) {
  const storeEnchancers = composeEnhancers(applyMiddleware(thunk.withExtraArgument(context)));

  return createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
    reducers,
    initialState,
    storeEnchancers,
  );
}
